import ReviewCategoryOutput from '@app/model/review/output/ReviewCategoryOutput';
import ReviewsStateStatistics from '@app/model/review/state/ReviewsStateStatistics';

export default class StateStatisticsForCategory {
	category: ReviewCategoryOutput;
	statistics: ReviewsStateStatistics;

	constructor(data: StateStatisticsForCategory) {
		Object.assign(this, data);
		this.statistics = new ReviewsStateStatistics(data.statistics);
	}
}
